import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { ModelName } from 'webapp/enums/enums';

import type MetricLibrarySourceController from 'webapp/controllers/metric-library/source';

import type SourceType from 'webapp/models-custom/source-type';
import type SourceRecord from 'webapp/models/source';

export default class MetricLibrarySourceSpecificRoute extends Route {
	@service('store') declare storeService: Service.Store;
	@service('navigation') declare navigationService: Service.Navigation;

	override model(params: { source_id: string }): SourceRecord | null | undefined {
		let source: SourceRecord | null | undefined;

		const genericSource = this.modelFor('metric-library.source') as SourceType;

		if (params.source_id) {
			source = this.storeService.peekRecord(
				ModelName.SOURCE,
				params.source_id,
			) as SourceRecord;
		}

		if (!source || !genericSource?.isSourceFromThisType(source)) {
			this.navigationService.transitionToRoute('metric-library.source', genericSource);
		}

		(this.controllerFor('metric-library.source') as MetricLibrarySourceController).set(
			'source',
			source,
		);

		return source;
	}
}
